import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M21 3C21 8.67 21 11.838 21 17.4H19.2V4.8H6.6V3C11.784 3 13.935 3 21 3ZM3 6.6C5.862 6.6 14.286 6.6 17.4 6.6C17.4 9.507 17.4 18.102 17.4 21C14.538 21 6.114 21 3 21C3 15.681 3 11.901 3 6.6ZM14.331 19.2L11.721 16.59L9.111 19.2H14.331ZM4.8 12.153L6.222 10.731L6.24 10.749L6.258 10.731L10.425 14.898L11.712 13.611L11.73 13.629L11.748 13.611L15.618 17.481V8.4H4.818V12.153H4.8ZM4.8 19.2H6.564L9.147 16.392L6.24 13.26L4.8 14.7V19.2ZM12.972 12.603C13.962 12.603 14.772 11.793 14.772 10.803C14.772 9.813 13.962 9.003 12.972 9.003C11.982 9.003 11.172 9.813 11.172 10.803C11.172 11.793 11.982 12.603 12.972 12.603Z' />
        </SvgIcon>
    );
});
